import { BaseActionOverlay } from '@adaptiva/core/overlays';
import { Vector2 } from '@adaptiva/core/space';
import { ICloudRelayServer } from '@adaptiva/operations-manager/common';
import { Directive, OnInit } from '@angular/core';

@Directive()
export abstract class CloudRelayOverlay extends BaseActionOverlay<ICloudRelayServer, ICloudRelayServer> implements OnInit {

	public geolocation: Vector2 = Vector2.null();

	public geolocationMin: Vector2 = new Vector2(-180.0, -90.0);

	public geolocationMax: Vector2 = new Vector2(180.0, 90.0);

	protected applyContext(_context: ICloudRelayServer): void {
		this.geolocation = new Vector2();
		this.geolocation.x = this.context.longitude ?? null;
		this.geolocation.y = this.context.latitude ?? null;
	}

	public ngOnInit(): void {
		if (this.context)
			this.applyContext(this.context);

		this.ready.next(true);
	}

	public setGeolocation(_location: Vector2): void {
		this.geolocation = _location;
		this.context.latitude = this.geolocation.x ?? null;
		this.context.longitude = this.geolocation.y ?? null;
	}

	protected abstract validate(): boolean;

	protected getGeolocationError(): string | null {
		if (
			(
				this.context.latitude === null &&
				this.context.longitude !== null
			) || (
				this.context.longitude === null &&
				this.context.latitude !== null
			)
		)
			return 'Please supply both latitude and longitude, or neither';

		return null;
	}

}
